import React from "react";
import ContentEditable from "react-contenteditable";

class Editor extends React.Component {
  constructor() {
    super();
    this.state = { html: ''};}
componentDidMount(){
  const {htmlContent}=this.props;
  this.setState({html:htmlContent})
}
  handleChange = evt => {
    const {updateHtmlContent}=this.props;
    this.setState({ html: evt.target.value });
    updateHtmlContent(evt.target.value);
  };

  render = () => {
    return (
      <ContentEditable
        html={this.state.html} 
        disabled={false} 
        onChange={this.handleChange} 
      />
    );
  };
}

export default Editor;
